export function getDeviceSnapshotFile(sn: string): string {
  return `${sn.replace(/[\\/]+/g, '_')}.json`;
}
